<template>
	<section>
		<!--工具条-->
		<el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
			<el-form :inline="true" :model="filters">
				<el-form-item>
					<el-input v-model="filters.demander" placeholder="供货单位" @input="getStock" clearable></el-input>
				</el-form-item>
				<el-form-item label="">
					<el-date-picker
				      v-model="filters.dates"
				      type="daterange"
				      align="left"
				      unlink-panels
				      range-separator="至"
				      start-placeholder="开始日期"
				      end-placeholder="结束日期"
				      :picker-options="pickerOptions"
				      @change="getStock">
				    </el-date-picker>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" v-on:click="getStock" >查询</el-button>
				</el-form-item>
			</el-form>
		</el-col>

		<!--列表-->
		<el-table :data="stocks" show-summary :summary-method="getSummaries" highlight-current-row v-loading="listLoading" style="width: 100%;">
			<el-table-column type="index" width="50">
			</el-table-column>
			<el-table-column prop="cdSn" label="单号" width="150">
			</el-table-column>
			<el-table-column prop="provider" label="供货单位" width="300">
			</el-table-column>
			<el-table-column prop="sum" label="金额" width="100">
			</el-table-column>
			<el-table-column prop="count" label="数量" width="100">
			</el-table-column>
			<el-table-column prop="username" label="操作员" width="100">
			</el-table-column>
			<el-table-column prop="createTime" label="入库时间" width="180">
			</el-table-column>
			<el-table-column label="操作" width="200">
				<template scope="scope">
					<el-button type="primary" size="small" @click="showStockDetail(scope.$index, scope.row)" icon="el-icon-search"></el-button>
					<el-button type="danger" size="small" v-if="isAdmin" @click="handleDel(scope.$index, scope.row)" icon="el-icon-delete"></el-button>
				</template>
			</el-table-column>
		</el-table>

		<!--工具条-->
		<el-col :span="24" class="toolbar">
			<el-pagination layout="total, prev, pager, next" @current-change="handleCurrentChange" :page-size="pageSize" :total="total" style="float:right;">
			</el-pagination>
		</el-col>

		<!--订单详情界面-->
		<el-dialog title="入库清单" :visible.sync="stockGoodsVisible" :close-on-click-modal="false">
			<el-table :data="stockGoods" highlight-current-row v-loading="stockGoodsLoading" style="width: 100%;" >
			    <el-table-column type="index" width="55">
				</el-table-column>
				<el-table-column prop="name" label="商品名称" width="200">
				</el-table-column>
				<el-table-column prop="brand" label="品牌" width="70">
				</el-table-column>
				<el-table-column prop="form" label="规格" width="150">
				</el-table-column>
				<el-table-column prop="unit" label="单位" width="70">
				</el-table-column>
				<el-table-column prop="price" label="单价" width="80">
				</el-table-column>
				<el-table-column prop="count" label="数量" width="80">
				</el-table-column>
			</el-table>
		</el-dialog>

	</section>
</template>

<script>
	import util from '../../common/js/util'
	import Cookies from 'js-cookie'
	import { getStockList, editStock, getStockDetail, delStock} from '../../api/api';

	var LODOP
	export default {
		data() {
			return {
				pageSize:20,
				pages:0,

				isAdmin: Cookies.get('user_type')==1,
				filters: {
					demander: '',
					dates: '',
				},

				stocks: [],
				total: 0,
				page: 1,
				listLoading: false,

				//查看页面
				stockGoodsVisible: false,//查看页面是否显示
				stockGoodsLoading: false,
				stockGoods: [],//物料列表

				//金额合计
				sums:['合计'],

				pickerOptions: {
	          shortcuts: [{
	            text: '最近一个月',
	            onClick(picker) {
	              const end = new Date();
	              const start = new Date();
	              start.setTime(start.getTime() - 3600 * 1000 * 24 * 365/12);
	              picker.$emit('pick', [start, end]);
	            }
	          }, {
	            text: '最近三个月',
	            onClick(picker) {
	              const end = new Date();
	              const start = new Date();
	              start.setTime(start.getTime() - 3600 * 1000 * 24 * 365/4);
	              picker.$emit('pick', [start, end]);
	            }
	          }, {
	            text: '最近半年',
	            onClick(picker) {
	              const end = new Date();
	              const start = new Date();
	              start.setTime(start.getTime() - 3600 * 1000 * 24 * 365/2);
	              picker.$emit('pick', [start, end]);
	            }
	          }, {
	            text: '最近一年',
	            onClick(picker) {
	              const end = new Date();
	              const start = new Date();
	              start.setTime(start.getTime() - 3600 * 1000 * 24 * 365);
	              picker.$emit('pick', [start, end]);
	            }
	          }]
	        },
			}
		},
		methods: {
			//分页
			handleCurrentChange(val) {
				this.page = val;
				this.getStock();
			},
			getSummaries(param) {
				return this.sums;
			},
			//获取订单列表
			getStock() {
				let start,end = '';
				if(this.filters.dates!='' && this.filters.dates!=undefined){
					start = util.formatDate.format(this.filters.dates[0],"yyyy-MM-dd 00:00:00");
					end = util.formatDate.format(this.filters.dates[1],"yyyy-MM-dd 23:59:59");
				}

				let para = {
					page:this.page,
          size:this.pageSize,
					demander: this.filters.demander,
					startTime:start==undefined?'':start,
          endTime:end==undefined?'':end,
				};
				this.listLoading = true;
				getStockList(para).then((res) => {
					this.listLoading = false
					let msg = res.data.message;
        	let code = res.data.code;
					if (code !== 200) {
            this.$message({
              message: msg,
              type: 'error'
            });
          } else {
          	this.stocks = res.data.data.pageInfo.list
            this.page = res.data.data.pageInfo.pageNum == 0 ? res.data.data.pageInfo.pageNum +1 : res.data.data.pageInfo.pageNum
            this.total = res.data.data.pageInfo.total
            this.sums[3] = res.data.data.stockSum+"元";
          }
				});
			},
			//根据入库id获取商品列表
			getGoodsByStockId(stockId) {
				let para = { 
					id: stockId 
				};
				this.stockGoodsLoading = true;
				getStockDetail(para).then((res) => {
					this.stockGoodsLoading = false;
					let msg = res.data.message;
                	let code = res.data.code;
					if (code !== 200) {
	                  this.$message({
	                    message: msg,
	                    type: 'error'
	                  });
	                } else {
						this.stockGoods = res.data.data
					}
				});
			},
			//查看送货单
			showStockDetail: function(index, row){
				this.getGoodsByStockId(row.id)
				this.stockGoodsVisible = true
			},
			//删除
			handleDel: function (index, row) {
				this.$confirm('确认删除该记录吗?', '提示', {
					type: 'warning'
				}).then(() => {
					this.listLoading = true;
					let para = { id: row.id,  status: 0 };
					delStock(para).then((res) => {
						this.listLoading = false;
						let msg = res.data.message;
	                	let code = res.data.code;
						if (code !== 200) {
		                  this.$message({
		                    message: msg,
		                    type: 'error'
		                  });
		                } else {
							this.$message({
								message: '删除成功',
								type: 'success'
							});
							this.getStock();
						}
					});
				}).catch(() => {
				});
			},
		},
		mounted() {
			this.getStock();
		}
	}

</script>

<style scoped>
  .demo-table-expand {
    font-size: 0;
  }
  .demo-table-expand label {
    width: 90px;
    color: #99a9bf;
  }
  .demo-table-expand .el-form-item {
    margin-right: 0;
    margin-bottom: 0;
    width: 50%;
  }

</style>